module.exports = {
      id: "qatar-usage",
      viewBox: "0 0 14 14",
      url: __webpack_public_path__ + "svg-sprite-39dbc991ee8a2ec1b35aeef6495011e2.svg#qatar",
      toString: function () {
        return this.url;
      }
    }